<div class="whats-new-container" [class.fade-out]="isClosing">
  <ng-container [ngTemplateOutlet]="xButton"></ng-container>
  <p class="title mb-0">{{ 'dialog.whats-new.title' | translate: lang }}</p>
  <img [src]="currentItem.svg.src" [alt]="currentItem.svg.alt" [style.opacity]="isTransitioning ? '0.3' : '1'" />
  <div class="info" [style.opacity]="isTransitioning ? '0.3' : '1'">
    <p class="title">{{ currentItem.title | translate: lang }}</p>
    <ng-container *ngIf="!isHelocItem(currentItem) && !isNewLowerStartingRatesItem(currentItem)">
      <p class="mb-0" [innerHTML]="currentItem.description | translate: lang"></p>
    </ng-container>
    <ng-container *ngIf="isHelocItem(currentItem)">
      <p class="mb-0 heloc-faqs-url" [innerHTML]="currentItem.description | translate: lang:{ link: helocFaqsUrl }"></p>
    </ng-container>
    <ng-container *ngIf="isNewLowerStartingRatesItem(currentItem)">
      <p class="mb-0" [innerHTML]="currentItem.description | translate: lang:{ link: quickQuoteUrl }"></p>
    </ng-container>
  </div>
  <div class="mt-3 d-flex" [class.justify-content-end]="currentModalIndex === 0" [class.justify-content-between]="currentModalIndex === whatsNewItems.length - 1 || (currentModalIndex !== 0 && currentModalIndex !== whatsNewItems.length - 1)">
    <ng-container [ngTemplateOutlet]="previousButton"></ng-container>
    <div class="align-items-center d-flex gap-3">
      <p *ngIf="whatsNewItems.length > 1" class="pages">
        {{ 'dialog.whats-new.pages' | translate: lang:{ index: currentModalIndex + 1, total: whatsNewItems.length } }}
      </p>
      <ng-container [ngTemplateOutlet]="nextButton"></ng-container>
    </div>
  </div>
</div>
<!-- Previous button -->
<ng-template #previousButton>
  <broker-button
    *ngIf="currentModalIndex > 0"
    [id]="'previous'"
    [style]="'outline-dark'"
    [icon]="'arrow'"
    [iconPosition]="'left'"
    [width]="'compact'"
    (clickEvent)="showPreviousPage()"
  >
    {{ 'dialog.whats-new.buttons.previous' | translate: lang }}
  </broker-button>
</ng-template>

<!-- Next button -->
<ng-template #nextButton>
  <broker-button
    *ngIf="currentModalIndex < whatsNewItems.length - 1"
    [id]="'next'"
    [style]="'primary'"
    [icon]="'arrow'"
    [iconPosition]="'right'"
    [width]="'compact'"
    (clickEvent)="showNextPage()"
  >
    {{ 'dialog.whats-new.buttons.next' | translate: lang }}
  </broker-button>

  <broker-button
    *ngIf="currentModalIndex >= whatsNewItems.length - 1"
    [id]="'continue'"
    [style]="'primary'"
    [width]="'compact'"
    (clickEvent)="close()"
  >
    {{ 'dialog.whats-new.buttons.continue' | translate: lang }}
  </broker-button>
</ng-template>

<!-- X button -->
<ng-template #xButton>
  <div class="position-absolute top-0 end-0 cursor-pointer" (click)="close()">
    <svg width="53" height="50" viewBox="0 0 53 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.740226 0H46C49.866 0 53 3.13401 53 7V49.8829C51.8737 49.9605 50.7369 50 49.5909 50C22.6043 50 0.727273 28.123 0.727273 1.13636C0.727273 0.756548 0.731606 0.377745 0.740226 0Z"
        fill="white"
      />
      <path
        d="M24 14.0001L36.7742 26.7743"
        stroke="#3A4146"
        stroke-width="2.08428"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24 26.7742L36.7742 14"
        stroke="#3A4146"
        stroke-width="2.08428"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</ng-template>
